import { OBRoutes } from '@utils/apiRoutes';
import { AppointmentResponse, AppointmentBody } from '@utils/interfaces';

import { useApiUrl } from '@gemini/lux-ds-pms';
import { excludeNull } from '@utils/functions';
import { UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useOBMutation } from './useOBMutation';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

export interface PutAppointmentError {
  type: string;
  title: string;
  status: number;
  detail: string;
  instance: string;
  code: string;
}

const usePutAppointment = (organizationId?: string) => {
  const refid = useOnlineBookingStore(state => state.refid);
  const queryParams = new URLSearchParams(
    excludeNull({
      organizationId,
      refid,
    }),
  );
  const url = `${useApiUrl(
    OBRoutes.Appointment,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )}?${queryParams}`;

  return useOBMutation<AppointmentResponse, AppointmentBody>(url, {
    method: 'PUT',
  }) as UseMutationResult<
    AppointmentResponse,
    AxiosError<PutAppointmentError>,
    AppointmentBody
  >;

  // return {
  //   data: [
  //     {
  //       success: true,
  //       appointmentId: 'de5d00d5-add6-469a-822f-7aa7a39dbee5',
  //       reservationId: 'b6118472-d188-4c31-9ca8-c73d0aa9b6f3',
  //       slotIds: [
  //         'd0c8c60b-fad4-4f07-9efd-8ddd39bf7714',
  //         '6f216588-4a03-4542-85a2-721eb30b7c67',
  //         '5877f9c7-32f3-47ea-ad36-6ef6c8787450',
  //       ],
  //       error: undefined,
  //     },
  //     {
  //       success: false,
  //       appointmentId: 'd320d376-3053-4ed9-b80b-8d6c2b58a777',
  //       reservationId: '75a2bdbf-cbab-453b-b7a3-1764e8f4c9e4',
  //       slotIds: [],
  //       error: {
  //         code: '500',
  //         message: 'error',
  //       },
  //     },
  //   ],
  //   isSuccess: true,
  //   isLoading: false,
  //   isError: false,
  //   mutate: (data: any) => {
  //     data;
  //   },
  //   error: undefined,
  // };
};

export default usePutAppointment;
